export const COMPANY = {
  name: "AGARTHA CONSTRUCTION",
  tagline: "Building Trust. Creating Landmarks.",
  hero: "From Drawing to Dream Home — We Build Everything.",
  phone: "+91 90350 99326",
  phoneRaw: "919035099326",
  whatsapp: "919035099326",
  email: "info@aconltd.com",
  address:
    "No. 759, Navy Layout, Opposite Maruthi Mandir, Kirloskar Layout Main Road, Bengaluru – 560073",
  shortAddress: "Kirloskar Layout, Bengaluru – 560073",
  mapsQuery:
    "Maruthi+Mandir+Kirloskar+Layout+Main+Road+Bengaluru+560073",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/quotation", label: "Quotation" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    key: "az",
    title: "A to Z Construction",
    desc:
      "End-to-end turnkey delivery — from soil to handover. Single contract, single accountable engineer, zero hand-off chaos.",
    icon: "Hammer",
    image:
      "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "materials",
    title: "Construction with Materials",
    desc:
      "Transparent per-sq.ft. packages with branded steel, cement, tiles & fittings. No hidden surprises.",
    icon: "Package",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "residential",
    title: "Residential Construction",
    desc: "Villas, luxury homes, independent houses & apartment buildings (G+3 to S+14).",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1706808849803-f61304e024ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "commercial",
    title: "Commercial Construction",
    desc: "Offices, showrooms, warehouses, retail shops and business complexes.",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "interiors",
    title: "Interior Solutions",
    desc: "Home & office interiors, modular kitchens, false ceilings and premium finishing.",
    icon: "Sofa",
    image:
      "https://images.pexels.com/photos/34277650/pexels-photo-34277650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "peb",
    title: "Pre-Engineered Buildings",
    desc: "Industrial sheds, warehouses and commercial PEB structures with rapid delivery.",
    icon: "Factory",
    image:
      "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "approvals",
    title: "Approval Drawings",
    desc: "BBMP approvals, plan sanctions, legal drawings — by a Registered BBMP Engineer.",
    icon: "FileSignature",
    image:
      "https://images.unsplash.com/photo-1742415106160-594d07f6cc23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "private",
    title: "Private Projects",
    desc: "Custom private builds tailored to bespoke briefs, budgets and timelines.",
    icon: "Compass",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const PACKAGES = [
  {
    key: "basic",
    name: "Basic",
    price: "2500",
    sub: "starting / sq.ft.",
    accent: "ink",
    highlight: false,
    features: [
      "2D Floor Plan",
      "Structural Design & Drawings",
      "3D Elevation",
      "2D Layout Plan",
      "Sunvik / Kamdhenu TMT (≤ ₹60,000/T)",
      "Birla Shakthi Cement (≤ ₹380/bag)",
      "Floor-to-Floor: 10 ft",
      "UPVC Windows incl. grill",
      "Tractor Emulsion Internal Paint",
      "Sintex 1,000 L Overhead Tank",
    ],
  },
  {
    key: "standard",
    name: "Standard",
    price: "2900",
    sub: "starting / sq.ft.",
    accent: "teal",
    highlight: true,
    features: [
      "Everything in Basic, plus:",
      "Electrical & Plumbing Drawings",
      "Meenakshi / Maharshi TMT (≤ ₹65,000/T)",
      "ACC / Birla Cement (≤ ₹400/bag)",
      "Floor-to-Floor: 10'6\"",
      "Birla Wall Care Putty + Tractor Shyne",
      "Apex Exterior Emulsion",
      "WPC Bathroom Doors",
      "SS Internal Railing (₹750/r.ft.)",
      "Sintex 1,500 L Triple-Layer Tank",
    ],
  },
  {
    key: "premium",
    name: "Premium",
    price: "3300",
    sub: "starting / sq.ft.",
    accent: "gold",
    highlight: false,
    features: [
      "Everything in Standard, plus:",
      "2D + 3D Layout Plan",
      "Geo-Technical Investigation Report",
      "Indus / Turbo TMT (≤ ₹68,000/T)",
      "Ultratech / Birla Super Cement",
      "Hydraulic Compressed 9\" Blocks",
      "Apcolite Premium Internal Paint",
      "Apex Ultima Exterior Paint",
      "6\"×4\" Teak Main Door (₹55,000)",
      "Compound Wall (4\" × 4 ft) Included",
      "Sintex 2,000 L Triple-Layer Tank",
    ],
  },
];

export const PROJECT_TYPES = [
  "Residential — Independent House",
  "Residential — Villa / Luxury Home",
  "Residential — Apartment Building",
  "Commercial — Office / Showroom",
  "Commercial — Warehouse / Shop",
  "Pre-Engineered Building (PEB)",
  "Interior Design Only",
  "Approval Drawings Only",
  "Other",
];

export const BUDGET_RANGES = [
  "Below ₹25 Lakhs",
  "₹25 – 50 Lakhs",
  "₹50 Lakhs – 1 Crore",
  "₹1 – 2 Crores",
  "₹2 – 5 Crores",
  "Above ₹5 Crores",
];

export const PROJECTS = [
  {
    title: "Karigiri Villa Estate",
    category: "Residential",
    location: "Hesaragatta Road",
    image:
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    spec: "G+2 • 6 BHK Villa • 5,800 sq.ft.",
  },
  {
    title: "Editorial Living — Interior Reset",
    category: "Interiors",
    location: "Yelahanka",
    image:
      "https://images.pexels.com/photos/34277650/pexels-photo-34277650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    spec: "3 BHK • Modular Kitchen • Full Turnkey",
  },
  {
    title: "Ironworks PEB Warehouse",
    category: "PEB",
    location: "Doddaballapur Road",
    image:
      "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    spec: "Single-Span • 28,000 sq.ft. • 6 mo.",
  },
  {
    title: "Monolith Studio Office",
    category: "Commercial",
    location: "Peenya",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    spec: "G+1 • Steel & Glass • 8,400 sq.ft.",
  },
  {
    title: "Foundation Works — Raft + Pile",
    category: "Structural",
    location: "Devanahalli",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    spec: "Pile Cap • SBC 220 kN/m² • 14m Depth",
  },
  {
    title: "BBMP Sanction — G+3 Layout",
    category: "Drawings",
    location: "Vidyaranyapura",
    image:
      "https://images.unsplash.com/photo-1742415106160-594d07f6cc23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    spec: "Plan Sanction • 3,200 sq.ft. Plot",
  },
];

export const TESTIMONIALS = [
  {
    name: "Anitha R.",
    role: "Homeowner • Yelahanka",
    quote:
      "Kiran sir personally walked us through every drawing and BBMP approval. The handover was on time and the finish quality is genuinely premium. We compared 5 builders — no one else had this technical depth.",
    rating: 5,
  },
  {
    name: "Vikram Shetty",
    role: "Director, Shetty Logistics",
    quote:
      "The PEB warehouse went up in under 6 months and passed every inspection on the first try. Engineering-led approach made the difference.",
    rating: 5,
  },
  {
    name: "Dr. Meera S.",
    role: "Apartment Owner • Hesaragatta",
    quote:
      "I trusted Agartha because Mr. Kiran is an actual government engineer. The transparency on materials (brand, bag rate, everything) is unheard of.",
    rating: 5,
  },
  {
    name: "Prakash N.",
    role: "Plot Owner • Devanahalli",
    quote:
      "From soil report to compound wall, single point of contact. The 3D elevation matched the final house almost exactly. Highly recommended.",
    rating: 5,
  },
];

export const STATS = [
  { value: "8+", label: "Years Govt. Project Experience" },
  { value: "S+14", label: "Maximum Floors Executed" },
  { value: "100%", label: "BBMP Compliant" },
];

export const FEATURES_INCLUDED = [
  "2D Floor Plans",
  "Structural Design & Drawings",
  "3D Elevation",
  "Electrical Drawings",
  "Plumbing Drawings",
  "Layout Plans",
  "Material Specifications",
  "Budget Planning",
  "Cost Estimation",
  "Instant Consultation",
];
